(function ($) {


	$(document).ready(function() {
		//open header subnav mobile menu
		$('#subNavMobile .header #openBtn .open').click(function() {
			$(this).fadeOut(100, function() {
				$('#subNavMobile .header #openBtn .close').fadeIn(100);
			});
		});

		//close header subnav mobile menu
		$('#subNavMobile .header #openBtn .close').click(function() {
			$(this).fadeOut(100, function() {
				$('#subNavMobile .header #openBtn .open').fadeIn(100);
			});
		});

  		$('.subnav-search .form-inline #search').attr('placeholder','Search EPE');

  		$('subnav-search').addClass('open');

		// Makes the Education Menu text clickable and swaps the open/close icons on click
		$('#subNavMobile .header .subNavHeading').click(function() {
			if($('#subNavMobile .header #openBtn .open').css('display') == 'block' ) {
				//alert("test");
				$('#subNavMobile .header #openBtn .open').fadeOut(100, function() {
					$('#subNavMobile .header #openBtn .close').fadeIn(100);
				});
			} else {
				$('#subNavMobile .header #openBtn .close').fadeOut(100, function() {
					$('#subNavMobile .header #openBtn .open').fadeIn(100);
				});		
			}
		});

		// Clicking an already open submenu item closes it
		$('#subNavMobile .slideOut .menu-sub-nav-container .menu .menu-item').click(function() {
				openItem = $(this).find('open');
				if (openItem) {
					event.stopPropagation();
					$('.open .sub-menu').slideUp('fast');
					//.removeClass("rotate");
					$(this).removeClass('open');
				}
		});
	});
     
}(jQuery));